module.exports = __webpack_public_path__ + "static/media/doc3.78f7162e.jpg";